import Vue from "vue"
export default {
  methods: {
    formatDate(date, type) {
      if (!date) return ''
      let format = type === 'accredit' ? 'MM月dd日' : 'yyyy.MM.dd'
      return new Date(date.replace(/-/g, "/")).format(format)
    }
  }
}